const controlCssClass = 'js-pagePrinter';

export default class PagePrinter {
    constructor() {
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    _init() {
        const controls = document.getElementsByClassName(controlCssClass);

        if (!controls || !controls.length) {
            return;
        }

        for (let i = 0; i < controls.length; i++) {
            const element = controls[i];
            element.addEventListener('click', (() => {
                this._printPage();
                return false;
            }).bind(this));
        }
    }

    _printPage() {
        window.print();
    }
}
